import script from "./SOptionGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./SOptionGroup.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import qInstall from "../../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QOptionGroup});
